// extracted by mini-css-extract-plugin
export var currencyInput = "_mu-1";
export var currencySymbol = "_mu-0";